import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});





// The click-tracking redirect (`/r/{id}`) lives outside `/api`, so strip that suffix off the base URL.
export const API_ORIGIN = api.defaults.baseURL.replace(/\/api\/?$/, "");
export const API_BASE_URL = api.defaults.baseURL;

const saved = localStorage.getItem("token");
if (saved) {
  // If you stored token as a JSON object: {"token":"..."}
  const parsed = JSON.parse(saved);
  const token = parsed?.token || parsed; // supports storing as raw string too
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export default api;
